import { Breadcrumb } from 'antd';
import styled from 'styled-components';

export const BreadcrumbWrapper = styled(Breadcrumb)`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  .ant-breadcrumb-link {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.green7};

    &:hover {
      color: ${({ theme }) => theme.colors.green8};
    }
  }

  li:last-child .ant-breadcrumb-link {
    color: ${({ theme }) => theme.colors.black7};
    cursor: default;

    &:hover {
      color: ${({ theme }) => theme.colors.black7};
    }
  }
`;
